import { CatIconSuccessFilled } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';

interface FullMatchFitmentProps {
  selectedEquipment?: {
    model?: string;
    serialNumber?: string;
  };
  shouldShowPartsDiagramV2?: boolean;
  className?: string;
}

const FullMatchFitment = ({
  selectedEquipment,
  shouldShowPartsDiagramV2,
  className = ''
}: FullMatchFitmentProps) => {
  const t = useTranslations();

  return (
    <p className={cx('d-flex m-0', className)}>
      <CatIconSuccessFilled color="success" className="pe-1" />
      <span className="cat-u-theme-typography-label-sm">
        {shouldShowPartsDiagramV2 ? (
          <>{t('PART_FACTORY_FIT')}</>
        ) : (
          <>
            {t('PART_FACTORY_FIT')}
            {selectedEquipment?.model} {selectedEquipment?.serialNumber}
          </>
        )}
      </span>
    </p>
  );
};

export default FullMatchFitment;
